module.exports = __webpack_public_path__ + "img/dog-food.10ca0e45.jpg";